import _ from 'lodash/fp'
import gql from 'graphql-tag'
import { all, call, put, takeLatest } from 'redux-saga/effects'

import { actions as metaDataActions, types as metaDataTypes } from '../reducers/trackingGroupsMetaData'

import { getCurrentClubId } from './network'

import { apolloClient } from '@fe/business/src/apollo'

const CLUB_TRACKING_GROUPS_COMMENTS_QUERY = gql`
  query ClubTrackingGroupsComments($clubId: ID!) {
    clubTrackingGroupsComments(clubId: $clubId) {
      id
      trackingGroupId
      comment
      owner
      status
      parentId
      imageIds
      createdAt
    }
  }
`

export function * loadCommentsEffect () {
  try {
    const clubId = yield call(getCurrentClubId)
    const response = yield call([apolloClient, apolloClient.query], {
      query: CLUB_TRACKING_GROUPS_COMMENTS_QUERY,
      variables: { clubId },
      fetchPolicy: 'network-only'
    })
    return _.getOr([], 'data.clubTrackingGroupsComments', response)
  } catch (error) {
    return { error }
  }
}

const CREATE_TRACKING_GROUP_COMMENT_MUTATION = gql`
  mutation CreateTrackingGroupComment($clubId: ID!, $trackingGroupId: ID!, $input: TrackingGroupCommentInput!) {
    createTrackingGroupComment(clubId: $clubId, trackingGroupId: $trackingGroupId, input: $input) {
      id
      trackingGroupId
      comment
      owner
      status
      parentId
      imageIds
      createdAt
    }
  }
`

export function * createCommentEffect (comment) {
  try {
    const clubId = yield call(getCurrentClubId)
    const trackingGroupId = _.get('trackingGroupId', comment)
    const response = yield call([apolloClient, apolloClient.mutate], {
      mutation: CREATE_TRACKING_GROUP_COMMENT_MUTATION,
      variables: {
        clubId,
        trackingGroupId,
        input: {
          comment: _.get('comment', comment)
        }
      }
    })
    return _.get('data.createTrackingGroupComment', response)
  } catch (error) {
    return { error }
  }
}

const UPDATE_TRACKING_GROUP_COMMENT_MUTATION = gql`
  mutation UpdateTrackingGroupComment($clubId: ID!, $commentId: ID!, $input: TrackingGroupCommentUpdateInput!) {
    updateTrackingGroupComment(clubId: $clubId, commentId: $commentId, input: $input) {
      id
      trackingGroupId
      comment
      owner
      status
      parentId
      imageIds
      createdAt
    }
  }
`

export function * updateCommentEffect (comment) {
  try {
    const clubId = yield call(getCurrentClubId)
    const commentId = _.get('id', comment)
    const response = yield call([apolloClient, apolloClient.mutate], {
      mutation: UPDATE_TRACKING_GROUP_COMMENT_MUTATION,
      variables: {
        clubId,
        commentId,
        input: {
          comment: _.get('comment', comment),
          status: _.get('status', comment)
        }
      }
    })
    return _.get('data.updateTrackingGroupComment', response)
  } catch (error) {
    return { error }
  }
}

const DELETE_TRACKING_GROUP_COMMENT_MUTATION = gql`
  mutation DeleteTrackingGroupComment($clubId: ID!, $commentId: ID!) {
    deleteTrackingGroupComment(clubId: $clubId, commentId: $commentId) {
      id
      trackingGroupId
      comment
      owner
      status
      parentId
      imageIds
      createdAt
    }
  }
`

export function * deleteCommentEffect (comment) {
  try {
    const clubId = yield call(getCurrentClubId)
    const commentId = _.get('id', comment)
    const response = yield call([apolloClient, apolloClient.mutate], {
      mutation: DELETE_TRACKING_GROUP_COMMENT_MUTATION,
      variables: { clubId, commentId }
    })
    return _.get('data.deleteTrackingGroupComment', response)
  } catch (error) {
    return { error }
  }
}

const CLUB_TRACKING_GROUPS_DESCRIPTIONS_QUERY = gql`
  query ClubTrackingGroupsDescriptions($clubId: ID!) {
    clubTrackingGroupsDescriptions(clubId: $clubId) {
      trackingGroupId
      name
      description
    }
  }
`

export function * loadDescriptionsEffect () {
  try {
    const clubId = yield call(getCurrentClubId)
    const response = yield call([apolloClient, apolloClient.query], {
      query: CLUB_TRACKING_GROUPS_DESCRIPTIONS_QUERY,
      variables: { clubId },
      fetchPolicy: 'network-only'
    })
    return _.getOr([], 'data.clubTrackingGroupsDescriptions', response)
  } catch (error) {
    return { error }
  }
}

const CREATE_TRACKING_GROUP_DESCRIPTION_MUTATION = gql`
  mutation CreateTrackingGroupDescription($clubId: ID!, $trackingGroupId: ID!, $input: TrackingGroupDescriptionInput!) {
    createTrackingGroupDescription(clubId: $clubId, trackingGroupId: $trackingGroupId, input: $input) {
      trackingGroupId
      name
      description
    }
  }
`

export function * createDescriptionEffect (description) {
  try {
    const clubId = yield call(getCurrentClubId)
    const trackingGroupId = _.get('trackingGroupId', description)
    const response = yield call([apolloClient, apolloClient.mutate], {
      mutation: CREATE_TRACKING_GROUP_DESCRIPTION_MUTATION,
      variables: {
        clubId,
        trackingGroupId,
        input: {
          name: _.get('name', description),
          description: _.get('description', description)
        }
      }
    })
    return _.get('data.createTrackingGroupDescription', response)
  } catch (error) {
    return { error }
  }
}

const UPDATE_TRACKING_GROUP_DESCRIPTION_MUTATION = gql`
  mutation UpdateTrackingGroupDescription($clubId: ID!, $trackingGroupId: ID!, $input: TrackingGroupDescriptionInput!) {
    updateTrackingGroupDescription(clubId: $clubId, trackingGroupId: $trackingGroupId, input: $input) {
      trackingGroupId
      name
      description
    }
  }
`

export function * updateDescriptionEffect (description) {
  try {
    const clubId = yield call(getCurrentClubId)
    const trackingGroupId = _.get('trackingGroupId', description)
    const response = yield call([apolloClient, apolloClient.mutate], {
      mutation: UPDATE_TRACKING_GROUP_DESCRIPTION_MUTATION,
      variables: {
        clubId,
        trackingGroupId,
        input: {
          name: _.get('name', description),
          description: _.get('description', description)
        }
      }
    })
    return _.get('data.updateTrackingGroupDescription', response)
  } catch (error) {
    return { error }
  }
}

const DELETE_TRACKING_GROUP_DESCRIPTION_MUTATION = gql`
  mutation DeleteTrackingGroupDescription($clubId: ID!, $trackingGroupId: ID!) {
    deleteTrackingGroupDescription(clubId: $clubId, trackingGroupId: $trackingGroupId) {
      trackingGroupId
      name
      description
    }
  }
`

export function * deleteDescriptionEffect (description) {
  try {
    const clubId = yield call(getCurrentClubId)
    const trackingGroupId = _.get('trackingGroupId', description)
    const response = yield call([apolloClient, apolloClient.mutate], {
      mutation: DELETE_TRACKING_GROUP_DESCRIPTION_MUTATION,
      variables: { clubId, trackingGroupId }
    })
    return _.get('data.deleteTrackingGroupDescription', response)
  } catch (error) {
    return { error }
  }
}

const UPLOAD_TRACKING_GROUP_COMMENT_IMAGE_MUTATION = gql`
  mutation UploadTrackingGroupCommentImage($clubId: ID!, $commentId: ID!, $input: TrackingGroupCommentImageInput!) {
    uploadTrackingGroupCommentImage(clubId: $clubId, commentId: $commentId, input: $input) {
      id
      commentId
      userId
    }
  }
`

export function * uploadImageEffect (payload) {
  try {
    const clubId = yield call(getCurrentClubId)
    const commentId = _.get('commentId', payload)
    const response = yield call([apolloClient, apolloClient.mutate], {
      mutation: UPLOAD_TRACKING_GROUP_COMMENT_IMAGE_MUTATION,
      variables: {
        clubId,
        commentId,
        input: {
          data: _.get('data', payload)
        }
      }
    })
    return _.get('data.uploadTrackingGroupCommentImage', response)
  } catch (error) {
    return { error }
  }
}

const DELETE_TRACKING_GROUP_COMMENT_IMAGE_MUTATION = gql`
  mutation DeleteTrackingGroupCommentImage($clubId: ID!, $commentId: ID!, $imageId: ID!) {
    deleteTrackingGroupCommentImage(clubId: $clubId, commentId: $commentId, imageId: $imageId)
  }
`

export function * deleteImageEffect (payload) {
  try {
    const { imageId, commentId } = payload
    const clubId = yield call(getCurrentClubId)
    const response = yield call([apolloClient, apolloClient.mutate], {
      mutation: DELETE_TRACKING_GROUP_COMMENT_IMAGE_MUTATION,
      variables: { clubId, commentId, imageId }
    })
    return _.get('data.deleteTrackingGroupCommentImage', response)
  } catch (error) {
    return { error }
  }
}

//  ███████╗ █████╗  ██████╗  █████╗ ███████╗
//  ██╔════╝██╔══██╗██╔════╝ ██╔══██╗██╔════╝
//  ███████╗███████║██║  ███╗███████║███████╗
//  ╚════██║██╔══██║██║   ██║██╔══██║╚════██║
//  ███████║██║  ██║╚██████╔╝██║  ██║███████║
//  ╚══════╝╚═╝  ╚═╝ ╚═════╝ ╚═╝  ╚═╝╚══════╝

function * loadCommentsFlow () {
  const result = yield call(loadCommentsEffect)
  const error = _.get('error', result)
  if (error) {
    yield put(metaDataActions.loadCommentsError(error))
  } else {
    const commentsObject = _.flow(
      _.groupBy('trackingGroupId'),
      _.mapValues(_.keyBy('id'))
    )(result)
    yield put(metaDataActions.loadCommentsSuccess(commentsObject))
  }
}

function * createCommentFlow ({ payload }) {
  const result = yield call(createCommentEffect, _.get('comment', payload))
  const error = _.get('error', result)
  if (error) {
    yield put(metaDataActions.createCommentError(error))
  } else {
    const dataArray = _.get('dataArray', payload)
    if (_.size(dataArray) > 0) {
      const imageUploadFns = _.map((data) => {
        return put(metaDataActions.uploadCommentImage({ data, commentId: _.get('id', result) }))
      }, dataArray)
      yield all(imageUploadFns)
    }
    yield put(metaDataActions.createCommentSuccess(result))
  }
}

function * updateCommentFlow ({ payload }) {
  const result = yield call(updateCommentEffect, _.get('comment', payload))
  const error = _.get('error', result)
  if (error) {
    yield put(metaDataActions.updateCommentError(error))
  } else {
    const dataArray = _.get('dataArray', payload)
    if (_.size(dataArray) > 0) {
      const imageUploadFns = _.map((data) => {
        return put(metaDataActions.uploadCommentImage({ data, commentId: _.get('id', result) }))
      }, dataArray)
      yield all(imageUploadFns)
    }
    yield put(metaDataActions.updateCommentSuccess(result))
  }
}

function * deleteCommentFlow ({ payload }) {
  const result = yield call(deleteCommentEffect, payload)
  const error = _.get('error', result)
  if (error) {
    yield put(metaDataActions.deleteCommentError(error))
  } else {
    const commentsObject = _.flow(
      _.groupBy('trackingGroupId'),
      _.mapValues(_.keyBy('id'))
    )(result)
    yield put(metaDataActions.deleteCommentSuccess(commentsObject))
  }
}

function * loadDescriptionsFlow () {
  const result = yield call(loadDescriptionsEffect)
  const error = _.get('error', result)
  if (error) {
    yield put(metaDataActions.loadDescriptionsError(error))
  } else {
    const descriptionsObject = _.keyBy('trackingGroupId', result)
    yield put(metaDataActions.loadDescriptionsSuccess(descriptionsObject))
  }
}

function * createDescriptionFlow ({ payload }) {
  const result = yield call(createDescriptionEffect, payload)
  const error = _.get('error', result)
  if (error) {
    yield put(metaDataActions.createDescriptionError(error))
  } else {
    yield put(metaDataActions.createDescriptionSuccess(result))
  }
}

function * updateDescriptionFlow ({ payload }) {
  const result = yield call(updateDescriptionEffect, payload)
  const error = _.get('error', result)
  if (error) {
    yield put(metaDataActions.updateDescriptionError(error))
  } else {
    yield put(metaDataActions.updateDescriptionSuccess(result))
  }
}

function * deleteDescriptionFlow ({ payload }) {
  const result = yield call(deleteDescriptionEffect, payload)
  const error = _.get('error', result)
  if (error) {
    yield put(metaDataActions.deleteDescriptionError(error))
  } else {
    const descriptionsObject = _.keyBy('trackingGroupId', [result])
    yield put(metaDataActions.deleteDescriptionSuccess(descriptionsObject))
  }
}

function * uploadImageFlow ({ payload }) {
  const result = yield call(uploadImageEffect, payload)
  const error = _.get('error', result)
  if (error) {
    yield put(metaDataActions.uploadCommentImageError(error))
  } else {
    yield put(metaDataActions.uploadCommentImageSuccess(result))
    yield put(metaDataActions.loadComments())
  }
}

function * deleteImageFlow ({ payload }) {
  const result = yield call(deleteImageEffect, payload)
  const error = _.get('error', result)
  if (error) {
    yield put(metaDataActions.deleteCommentImageError(error))
  } else {
    yield put(metaDataActions.deleteCommentImageSuccess(result))
    yield put(metaDataActions.loadComments())
  }
}

export default function * () {
  return yield all([
    takeLatest(metaDataTypes.LOAD_COMMENTS, loadCommentsFlow),
    takeLatest(metaDataTypes.CREATE_COMMENT, createCommentFlow),
    takeLatest(metaDataTypes.UPDATE_COMMENT, updateCommentFlow),
    takeLatest(metaDataTypes.DELETE_COMMENT, deleteCommentFlow),
    takeLatest(metaDataTypes.LOAD_DESCRIPTIONS, loadDescriptionsFlow),
    takeLatest(metaDataTypes.CREATE_DESCRIPTION, createDescriptionFlow),
    takeLatest(metaDataTypes.UPDATE_DESCRIPTION, updateDescriptionFlow),
    takeLatest(metaDataTypes.DELETE_DESCRIPTION, deleteDescriptionFlow),
    takeLatest(metaDataTypes.UPLOAD_COMMENT_IMAGE, uploadImageFlow),
    takeLatest(metaDataTypes.DELETE_COMMENT_IMAGE, deleteImageFlow)
  ])
}
